import BasePage from "./basePage";

export default class Page5 extends BasePage{
    constructor(info){
        super(info);
        super.set();

        this.ele = info.ele;
        this.pageTl = new TimelineMax({ paused: true, ease: Power2.easeOut });
        this._pageSet();
        this._bindEvent();
    }

    _pageSet(){
        this.pageTl
            .fromTo( this.ele.querySelector('.tit strong em'), 1, { y: "100%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, delay: 0.3, ease: Back.easeOut.config(1.05) })
            .fromTo( this.ele.querySelector('.tit span em'), 1, { y: 90, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Back.easeOut.config(1.05) }, "-=0.7")

            .fromTo( this.ele.querySelector('.char-left-2'), 0.6, { y: 80, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Back.easeOut }, 'mo1')
            .fromTo( this.ele.querySelector('.char-right-1'), 0.6, { x: 80, y: 80, autoAlpha: 0 }, { x: 80, y: 0, autoAlpha: 1, ease: Back.easeOut }, 'mo1')

            .fromTo( this.ele.querySelector('.char-left-1'), 0.5, { x: 80, autoAlpha: 0 }, { x: 0, autoAlpha: 1, ease: Power4.easeOut }, 'mo2')
            .fromTo( this.ele.querySelector('.char-left-3'), 0.5, { x: -80, autoAlpha: 0 }, { x: 0, autoAlpha: 1, ease: Power4.easeOut }, 'mo2')
            .fromTo( this.ele.querySelector('.char-right-2'), 0.5, { x: -80, autoAlpha: 0 }, { x: 0, autoAlpha: 1, ease: Power4.easeOut }, 'mo2')
            .to( this.ele.querySelector('.char-right-1'), 0.5, { x: -80, ease: Power4.easeOut }, 'mo2')

            .addLabel('mo3', '-=0.4')
            .fromTo( this.ele.querySelector('.btn-7d'), 0.5, { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, 'mo3')
            .fromTo( this.ele.querySelector('.btn-lucky'), 0.5, { y: 40, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Power2.easeOut }, 'mo3')

            // .to( this.ele.querySelector('.light-1'), 0.9, { autoAlpha: 0, yoyo: true, repeat: 1, ease:  Bounce.easeIn }, "-=1.2")
            // .to( this.ele.querySelector('.light-2'), 0.9, { autoAlpha: 0, yoyo: true, repeat: 1, ease:  Bounce.easeIn }, "-=1.75")
    }


    _pageMotion(){
        this.pageTl.restart();
    }

    _bindEvent(){
        this.ele.addEventListener('onComplete', this._pageMotion.bind(this) );
    }

    show(){
        super.show();
    }

    hide(){
        super.hide();
        setTimeout(()=>{
            this.pageTl.reverse();
        }, 500)
    }
}


// WEBPACK FOOTER //
// ./src/js/mainDeath/page5.js